import { WALL } from "@/constants/testIds";

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export default function WallOfSupport({ items }) {
  return (
    <section id="wall" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-slate-500">// Wall of support</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-2">
              Every backer, named & numbered
            </h2>
          </div>
          <div className="font-mono text-xs uppercase tracking-widest text-slate-500">
            {items?.length ?? 0} entries
          </div>
        </div>

        {(!items || items.length === 0) ? (
          <div className="border border-dashed border-white/15 bg-slate-950/50 p-12 text-center">
            <div className="font-mono text-xs uppercase tracking-widest text-slate-500">// No entries yet</div>
            <p className="mt-3 text-slate-400">Be the first to leave your name on the wall — donate or pledge above.</p>
          </div>
        ) : (
          <div data-testid={WALL.list} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {items.map((it, i) => (
              <div
                key={it.id || `${it.kind}-${it.created_at}-${i}`}
                data-testid={WALL.item(i)}
                className="relative p-5 bg-slate-950/70 border border-white/10 hover:border-white/25 transition-colors"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-display font-bold text-lg text-white truncate">{it.name}</div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-0.5">
                      {it.kind === "donation" ? "DONATED" : "PLEDGED"} · {fmtDate(it.created_at)}
                    </div>
                  </div>
                  <div className={`font-display text-xl font-black ${it.kind === "donation" ? "text-kinetic" : "text-slate-300"}`}>
                    ${Number(it.amount || 0).toLocaleString()}
                  </div>
                </div>
                {it.message && (
                  <p className="mt-3 text-sm text-slate-300 border-l-2 border-kinetic/60 pl-3 italic">
                    &ldquo;{it.message}&rdquo;
                  </p>
                )}
                {it.tier_id && (
                  <div className="mt-3 inline-block px-2 py-0.5 border border-white/15 font-mono text-[10px] uppercase tracking-widest text-slate-400">
                    {it.tier_id.replace(/_/g, " ")}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
